import React from "react";
import AuditLogList from "@/components/AuditLogList";

export default function AdminAudit() {
  return (
    <div className="px-8 py-8 max-w-7xl">
      <div className="text-[11px] uppercase tracking-[0.3em] text-zinc-500">Studio</div>
      <h1 className="font-display text-4xl tracking-tight mt-1 mb-8">Audit log</h1>
      <AuditLogList scope="admin" />
    </div>
  );
}
